export const SKINS = {
  standard: 'standard',
  premium: 'premium',
  dark: 'dark',
  light: 'light',
  destructive: 'destructive',
};

export const SIZES = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
};

export const WEIGHT = {
  thin: 'thin',
  secondary: 'normal',
};
